export const SIGN_OK_FIRMA_AVANZADA = 'SIGN_OK_FIRMA_AVANZADA';
export const SET_SELECT_IDTSA = 'SIGNCUSTOM_SET_SELECT_IDTSA';
export const SET_LIST_HANDWRITTE = 'SIGNCUSTOM_SET_LIST_HANDWRITE';
export const LOADING = 'SIGNCUSTOM_LOADING';